import { z } from 'zod'

const HEX_COLOR_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/

export const isValidHexColor = (value: string): boolean => HEX_COLOR_PATTERN.test(value)

export const hexColorSchema = z.string().refine(isValidHexColor, {
  message: 'Enter a valid hex color (e.g. #23A9C2 or #FFF)',
})
